import { createAsyncThunk } from "@reduxjs/toolkit";
import { getProducts } from "./api/product";

export const fetchGetProduct = createAsyncThunk(
  "getProduct",
  async (param: {
    gti: string;
    query?: string;
    isNewArrival?: boolean;
    categoryKeys?: string[];
    concerns?: string[];
    type?: string;
  }) => {
    const response = await getProducts(
      param.gti,
      param.query,
      param.isNewArrival,
      param.categoryKeys,
      param.concerns,
      param.type
    );
    return response?.data;
  }
);
